import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { GlobalService } from 'src/app/core/services/global.service';
import { environment } from '../../../environments/environment';
import { StorageHandler } from 'src/app/shared/handlers/storage-handler';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const globalService = inject(GlobalService);
  if (globalService.authenticated) {
    if (state.url.includes('auth')) {
      router.navigate(['app']);
    }
    return true;
  } else if (environment.msalEnabled) {
    if (state.url.includes('/auth/msal-login') || state.url.includes('/auth/msal-logout')) {
      return true;
    }
    router.navigate(['auth/msal-login']);
    const uuid = globalService.create_UUID();
    StorageHandler.setLocalStorage('state', uuid);
    const redirectUrl = `https://login.microsoftonline.com/${environment.msalTenant}/oauth2/v2.0/authorize?
        client_id=${environment.msalClient}
        &response_type=code
        &redirect_uri=${environment.msalRedirectUrl}
        &response_mode=query
        &scope=openid%20offline_access%20user.read
        &state=${uuid}`;
    setTimeout(function () {
      location.replace(redirectUrl);
    }, 0);
    return false;
  } else {
    if (state.url.includes('/auth/login') || state.url.includes('/auth/logout')) {
      return true;
    }
    router.navigate(['auth/login']);
    return false;
  }
};
